import React, { useState, useEffect } from 'react';
import {
  CssBaseline,
  Grid,
  makeStyles,
  TableBody,
  TableCell,
  TableHead,
  TableRow as MaterialTableRow,
  Typography,
  withStyles,
} from '@material-ui/core';

import axiosInstance, { WEB_API, getEventId } from '../../constatns';
import AdminTopbar from '../AdminTopbar';
import AdminFooter from '../AdminFooter';
import { CountryList } from '../../common/CountryList';
import SubTitle from '../../components/Text/SubTitle';
import Table from '../../components/Table/Table';
import { gridColumnsTotalWidthSelector } from '@material-ui/data-grid';

const styles = makeStyles((theme) => ({
  root: {
    minHeight: 800,
    overflow: 'auto',
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: '1px solid rgba(224, 224, 224, 1)',
    },
    '& .MuiTableCell-root': {
      textAlign: 'center',
      fontSize: '13px',
      // minWidth: 100,
      '& span': {
        display: 'block',
        wordBreak: 'keep-all',
      },
      '& button': {
        fontSize: '13px',
      },
    },
    '& > div:not(:first-child)': {
      marginBottom: '30px',
    },
  },
  subTitle: {
    fontSize: '1.2em',
    fontWeight: 600,
    paddingLeft: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

const TableRow = withStyles((theme) => ({
  root: {
    '& > th:not(:last-of-type)': {
      borderRight: '1px solid rgba(224, 224, 224, 0.5)',
    },
    '& > td:not(:last-of-type)': {
      borderRight: '1px solid rgba(224, 224, 224, 0.5)',
    },
  },
}))(MaterialTableRow);

const StatusPage = (props) => {
  const classes = styles();

  /*
   * 필요한 state
   * 총등록자수 - 국내, 국외, 합계
   * 등록구분별 - ealry, last, onsite
   * 결제수단별 - 카드, 송금, free(isFree)
   * 회원구분별 - 개원의, ...
   * 국가별 -
   */

  const [count, setCount] = useState({}); //총등록자수
  const [country, setCountry] = useState([]); // 국가

  useEffect(() => {
    init();
  }, []);

  const init = () => {
    axiosInstance.get(`${WEB_API}/speaker/list?eventId=${getEventId()}&limit=-1`, { headers: { Pragma: 'no-cache' } }).then((response) => {
      /*
        // 등록자(isPay 값이 R)만 확인
        for (let item of response.data.Items) {
          if (item.isPay === 'R') {
            console.log(item);
          }
        }
      */
      // console.log(response.data);
      showChart(response.data);
      getPresentationChart(response.data);
      renderAbstractTopicChart(response.data);
    });
  };

  const showChart = (d) => {
    setCount({
      total: d.length,
      korean: 0,
      international: 0,
      basicresearch: 0,
      craniofacial: 0,
      handupperlimb: 0,
      headneck: 0,
      breastbody: 0,
      lowerlimb: 0,
    });

    //총등록자 및 세션별
    d.map((item) => {
      setCount((prevState) => ({
        ...count,
        total: prevState['total'],
        korean: item.country === 'Korea, Republic of' ? prevState['korean'] + 1 : prevState['korean'],
        international: item.country !== 'Korea, Republic of' ? prevState['international'] + 1 : prevState['international'],
        basicresearch:
          item.session && item.session === '기초연구 (Basic Research)' ? prevState['basicresearch'] + 1 : prevState['basicresearch'],
        craniofacial:
          item.session && item.session === '두개안면 및 외상 (Craniofacial & Trauma)'
            ? prevState['craniofacial'] + 1
            : prevState['craniofacial'],
        handupperlimb:
          item.session && item.session === '수부 및 상지 재건 (Hand & Upper Limb Reconstruction)'
            ? prevState['handupperlimb'] + 1
            : prevState['handupperlimb'],
        headneck:
          item.session && item.session === '두경부 재건 (Head and Neck Reconstruction)' ? prevState['headneck'] + 1 : prevState['headneck'],
        breastbody:
          item.session && item.session === '유방 체부 재건 (Breast Body Reconstruction)'
            ? prevState['breastbody'] + 1
            : prevState['breastbody'],
        lowerlimb:
          item.session && item.session === '하지재건 (Lower Limb Reconstruction)' ? prevState['lowerlimb'] + 1 : prevState['lowerlimb'],
      }));
    });

    // 국가별
    let buff = [];
    for (let i = 0; i < CountryList.length; i++) {
      // if (CountryList[i].name !== 'Korea, Republic of') {
      buff.push({
        name: CountryList[i].name,
        count: 0,
      });
      // }
    }
    if (d) {
      for (let i = 0; i < d.length; i++) {
        for (let j = 0; j < buff.length; j++) {
          if (buff[j].name === d[i].country) {
            buff[j].count += 1;
          }
        }
      }
    }
    setCountry(buff);
  };

  // Presentation Type 수 통계 테이블 렌더링
  const getPresentationChart = () => {
    return (
      <>
        <Table>
          <TableBody className={classes.registerStateTable}>
            <TableRow>
              <TableCell>등록현황</TableCell>
              <TableCell>
                <div>
                  <div>전체 : {count['total']}</div>
                  <div>국내 : {count['korean']}</div>
                  <div>해외 : {count['international']}</div>
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </>
    );
  };

  // Abstract Topic 통계 테이블 렌더링
  const renderAbstractTopicChart = () => {
    return (
      <>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>세션이름</TableCell>
              <TableCell>인원</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>기초연구 (Basic Research)</TableCell>
              <TableCell align="center">{count['basicresearch']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>두개안면 및 외상 (Craniofacial & Trauma)</TableCell>
              <TableCell align="center">{count['craniofacial']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>수부 및 상지 재건 (Hand & Upper Limb Reconstruction)</TableCell>
              <TableCell align="center">{count['handupperlimb']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>두경부 재건 (Head and Neck Reconstruction)</TableCell>
              <TableCell align="center">{count['headneck']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>유방 체부 재건 (Breast Body Reconstruction)</TableCell>
              <TableCell align="center">{count['breastbody']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>하지재건 (Lower Limb Reconstruction)</TableCell>
              <TableCell align="center">{count['lowerlimb']}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </>
    );
  };

  // 국가별 통계 테이블 렌더링
  const renderCountryChart = () => {
    return (
      <>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>국가명</TableCell>
              <TableCell>인원</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {country.map(
              (item) =>
                item.count > 0 && (
                  <TableRow key={item.name}>
                    <TableCell>{item.name}</TableCell>
                    <TableCell align="center">{item.count}</TableCell>
                  </TableRow>
                ),
            )}
          </TableBody>
        </Table>
      </>
    );
  };

  return (
    <Grid item xs={12}>
      <CssBaseline />
      <AdminTopbar MIdx={7} SIdx={0} />
      <Grid container alignItems={'stretch'} direction="column" style={{ padding: 16 }} className={classes.root}>
        <Grid item>
          <Grid container spacing={4} justifyContent={'flex-start'} alignItems={'center'}>
            <Grid item>
              <h1>Status - Speaker</h1>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <SubTitle isDecoHidden={true}>총 등록자</SubTitle>
          {count && getPresentationChart()}
        </Grid>
        <Grid item>
          <SubTitle isDecoHidden={true}>세션별 통계</SubTitle>
          {count && renderAbstractTopicChart()}
        </Grid>
        <Grid item>
          <SubTitle isDecoHidden={true}>국가별 통계</SubTitle>
          {country && renderCountryChart()}
        </Grid>
      </Grid>
      <AdminFooter />
    </Grid>
  );
};
export default StatusPage;
